import { render, staticRenderFns } from "./division-main.vue?vue&type=template&id=ed9dfcd2&scoped=true&"
import script from "./division-main.vue?vue&type=script&lang=js&"
export * from "./division-main.vue?vue&type=script&lang=js&"
import style0 from "./division-main.vue?vue&type=style&index=0&id=ed9dfcd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9dfcd2",
  null
  
)

export default component.exports